import React, {useState, useEffect} from "react";
import {
  Box,
  Text,
  Textarea,
  Button,
  useColorModeValue,
  useToast,
} from "@chakra-ui/react";
import { cqAPI } from "../../lib/Auth";

const CustomizeAI = () => {
  const bgColor = useColorModeValue("gray.100", "gray.700");

  const [instructions, setInstructions] = useState("");
  const toast = useToast();

  const place_holder_text = ""

  // Fetch existing instructions when component mounts
  useEffect(() => {
    const loadInstructions = async () => {
      try {
        const response = await cqAPI.get("/settings/load-instructions");
        console.log(`LOAD RESPONSE: ${response.data.instructions}`)
        if (response.data && response.data.instructions) {
          setInstructions(response.data.instructions || place_holder_text);
        } else {
          console.log("No existing instructions found.");
          setInstructions(place_holder_text);
        }
      } catch (error) {
        console.error("Error loading instructions:", error);
        toast({
          title: "Error",
          description: "Failed to load instructions.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    };

    loadInstructions();
  }, [toast]);

  const handleSave = async () => {
    try {
      const response = await cqAPI.post("/settings/save-instructions", {
        instructions: instructions,
      });

      if (response.success) {
        toast({
          title: "Saved successfully.",
          description: "Your instructions have been saved.",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      } else {
        throw new Error(response.message || "Failed to save.");
      }
    } catch (error) {
      toast({
        title: "Error",
        description: error.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
      <Box p={4} overflowY="auto" maxH="100vh" w="100%" align="left">
      <Box mb={4} display="flex" justifyContent="flex-start">
        <Button colorScheme="blue" size="md" onClick={handleSave}>
          Save
        </Button>
      </Box>
      <Box p={4} bgColor={bgColor} borderRadius="md">
        <Text fontSize="lg" mb={2}>
          What would you like <strong>Response Suggestion</strong> to know about your practice to provide better responses?
        </Text>
        <Textarea
          placeholder="Enter your instructions here..."
          id="ai_instructions"
          size="lg"
          minH="120px"
          value={instructions}
          onChange={(e) => setInstructions(e.target.value)}
        />
      </Box>
    </Box>
  );
};

export default CustomizeAI;
